export default "__VITE_ASSET__DlszJoFu__"